import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useOutletContext } from 'react-router-dom';

import { IUser, pageInfoState, userState } from '../../atoms';
import { ITabObject } from 'customTypes';
import { VIDEO_TYPE_VISITOR } from '../../_constants';
import Tab from '../../components/Tab';
import SafeEduExamSetting from '../../components/SafeEduExamSetting';
import JobtypeVideo from '../../components/JobtypeVideo';
import InputList from '../../components/InputList';
import EdutermSetting from './setting13/EdutermSetting';
import QrCode from '../../components/QrCode';
import SafeEduListForm from './setting13/SafeEduListForm';

const SMSetting13 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const userInfo = useRecoilValue<IUser>(userState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { userMenuList } = userInfo;
  const PURPOSE = { type: 'purpose', endPoint: '/visit/purpose', dtoKey: 'visitPurposeReqDto', nameKey: 'pName', codeKey: 'pCd', responseArrayKey: '' };
  const DEPT = { type: 'dept', endPoint: '/visit/dept', dtoKey: 'visitDeptReqDto', nameKey: 'deptName', codeKey: 'deptCd', responseArrayKey: '' };

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList //
        ?.find(
          (el: ITabObject) =>
            el.mtCd === v.mtCd && //
            el.mdCd === v.mdCd &&
            el.mrCd === v.mrCd
        );
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = userMenuList.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <JobtypeVideo sType={VIDEO_TYPE_VISITOR} excludeVideoLanguages={['id', 'ms', 'kk', 'mn']} />; // 동영상 설정
        case '002':
          return <SafeEduExamSetting examType='VISITOR' excludeLanguages={['I', 'Y', 'Z', 'L']} />; // 문답 설정
        case '003':
          return <InputList prop={DEPT} />; // 부서 설정
        case '004':
          return <InputList prop={PURPOSE} />; // 목적 설정
        case '005':
          return <EdutermSetting />; // 기타 설정
        case '006':
          return <QrCode />; // QR 코드
        case '007':
          return <SafeEduListForm />; // 방문자 서약서
      }
    }
    return null;
  };

  return (
    <div className='contents'>
      <Tab
        tabList={newTabList || tabInfo.tabList} //
        currentTabMrCd={currentTabMrCd}
        setCurrentTabMrCd={setCurrentTabMrCd}
        onClickTab={onClickTab}
        size={size}
      />
      {renderPage()}
    </div>
  );
};

export default SMSetting13;
